/* @ngInject */
const myWagonDisplayHeader = (
  $$railway,
  $$train
) => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
    },
    template: require('./myWagonDisplayHeader.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.$$train = $$train
      $scope.$$railway = $$railway
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}

export default myWagonDisplayHeader



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/display/myWagonDisplayHeader.js